"use client";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React, { Fragment } from "react";
export function DesktopMenu(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(Popover.Group, {
        className: "hidden lg:flex lg:gap-x-12"
    }, children);
}
export function DesktopMenuDropDown(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ React.createElement(Popover, {
        className: "relative",
        as: "li"
    }, /*#__PURE__*/ React.createElement(Popover.Button, {
        className: "link-main-navigation after:top-6 flex items-center gap-1 focus-dark"
    }, title, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: "h-5 w-5 flex-none",
        "aria-hidden": "true"
    })), /*#__PURE__*/ React.createElement(Transition, {
        as: Fragment,
        enter: "transition ease-out duration-200",
        enterFrom: "opacity-0 translate-y-1",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease-in duration-150",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 translate-y-1"
    }, /*#__PURE__*/ React.createElement(Popover.Panel, {
        className: "absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-green-800/5",
        as: "ul"
    }, children)));
}
